<template>
  <v-stepper v-model="current" dark>
    <!-- Header solo para múltiples pasos -->
    <v-stepper-header v-if="steps > 1 && localValue[0] && !localValue[0].padre">
      <template v-for="n in steps">
        <v-stepper-step :key="n.toString() + '-step'" :complete="current > n" :step="n">
          {{ localValue[n - 1].strNombre }}
          <small v-if="another_stepper(localValue[n - 1])">PASO REQUERIDO</small>
          <small v-else-if="localValue[n - 1].intCantidadSeleccionable > 0"
            >SELECCIONE {{ localValue[n - 1].intCantidadSeleccionable }}</small
          >
          <small v-else>OPCIONAL</small>
        </v-stepper-step>
        <v-divider v-if="n !== steps" :key="n"></v-divider>
      </template>
    </v-stepper-header>
    
    <v-stepper-items>
      <v-stepper-content v-for="n in steps" :key="n.toString() + '-content'" :step="n">
        <v-container fluid v-if="!another_stepper(localValue[n - 1])">
          <v-row>
            <v-col
              md="2"
              :key="hijo.intArticuloConfiguration"
              v-for="hijo in localValue[n - 1].hijos"
            >
              <v-card
                min-height="100%"
                :key="hijo.intArticuloConfiguration"
                @click="selected(n, hijo)"
                :color="hijo.color"
                light
              >
                <v-img :src="hijo.strImagen" height="80px"></v-img>
                <v-card-title>
                  <h6>
                    {{ hijo.strNombreCorto + " - " + isMoney(hijo.dblPrecio) }}
                  </h6>
                </v-card-title>
                <v-card-subtitle>{{ hijo.strNombre }}</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          
          <v-col>
            <v-btn
              md="2"
              :key="hijo.intArticuloConfiguration"
              v-for="hijo in localValue[n - 1].hijos.filter((x) => x.selected)"
              @click="eliminar(hijo)"
            >
            ({{ hijo.dblCantidad }}) {{ hijo.strNombre }}
            </v-btn>
          </v-col>
        </v-container>
        
        <v-container fluid v-else>
          <ArticuloStepper
            @finishChild="finishChild"
            @nextchild="nextChild"
            v-model="localValue[n - 1].hijos"
            :child="true"
            :childstep="n"
            :steps="getSteps(localValue[n - 1])"
          />
        </v-container>
        
        <!-- Controles de navegación adaptativos -->
        <v-row v-if="!another_stepper(localValue[n - 1])">
          <!-- Botón Atrás: solo si hay múltiples pasos y no es el primero -->
          <v-col v-if="steps > 1 && current > 1">
            <v-btn block color="secondary" @click="backStep">Atras</v-btn>
          </v-col>
          
          <!-- Botón Siguiente: solo si hay múltiples pasos y no es el último -->
          <v-col v-if="steps > 1 && current < steps">
            <v-btn
              block
              color="primary"
              :disabled="!isStepValid(n)"
              @click="nextStep"
            >Siguiente</v-btn>
          </v-col>
          
          <!-- Botón Terminar: para último paso o único paso -->
          <v-col v-if="current == steps || steps === 1">
            <v-btn
              block
              color="success"
              :disabled="!isStepValid(n)"
              @click="finish"
            >Terminar</v-btn>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { Toast, ErrorWeb } from "../controllers/DataController.js";
import { isMoney } from "../js/utilities";
import { POSDetArticuloConfiguracion } from "../controllers/POSController";

export default {
  name: "ArticuloStepper",
  expose: ['reload'],
  props: {
    value: { required: true },
    steps: { type: Number, default: 1 },
    child: { type: Boolean, default: false },
    childstep: { type: Number, default: 0 },
  },
  data() {
    return {
      localValue: this.value,
      current: 1,
      configuracionesTemporal: [],
    };
  },
  methods: { 
    isMoney,
    
    isStepValid(step) {
      const config = this.localValue[step - 1];
      if (!config) return false;
      
      const totalSeleccionado = config.hijos
        .filter(x => x.dblCantidad > 0)
        .reduce((a, b) => a + b.dblCantidad, 0);
      
      return (
        config.intCantidadSeleccionable === 0 ||
        config.intCantidadSeleccionable === totalSeleccionado
      );
    },
    
    another_stepper(configuration) {
      if (!configuration || !configuration.hijos) return false;
      return configuration.hijos.filter(hijo => hijo.intPaso == 1).length > 0;
    },
    
    eliminar(hijo) {
      hijo.dblCantidad = (hijo.dblCantidad || 0) - 1;
      
      if (hijo.dblCantidad == 0) {
        hijo.color = "#ffffff";
        hijo.selected = false;
      }
      this.$forceUpdate();
    },
    
    selected(step, hijo) {
      try {
        // SIEMPRE se incrementa la cantidad, nunca se deselecciona
        // Solo verificamos el límite máximo
        if (this.localValue[step - 1].intCantidadSeleccionable > 0) {
          let totalSeleccionado = this.localValue[step - 1].hijos
            .filter((x) => x.dblCantidad > 0)
            .reduce((a, b) => { return a + b.dblCantidad; }, 0);
          
          // Verificar si al agregar uno más se excede el límite
          if (this.localValue[step - 1].intCantidadSeleccionable < totalSeleccionado + 1) {
            throw (
              "Solo puede seleccionar " +
              this.localValue[step - 1].intCantidadSeleccionable +
              " opciones"
            );
          }
        }
        
        // Siempre marcar como seleccionado y aumentar cantidad
        hijo.color = "primary";
        hijo.selected = true;
        hijo.dblCantidad = (hijo.dblCantidad || 0) + 1;
        this.$forceUpdate();
        
      } catch (e) {
        this.$toast.error(
          "Error en " + this.localValue[step - 1].strNombre + ". " + e,
          new Toast()
        );
      }
    },
    
    finish() {
      this.loading = true;
      try {
        let POSDetArticuloConfiguraciones = [];
        
        // Procesar todos los pasos
        this.localValue.forEach((config) => {
          if (config && config.hijos) {
            config.hijos
              .filter(x => x.selected)
              .forEach((x) => {
                POSDetArticuloConfiguraciones.push(new POSDetArticuloConfiguracion(x, 0));
              });
          }
        });
        
        this.current = 1;
        
        if (this.child) {
          this.$emit("finishChild", POSDetArticuloConfiguraciones);
        } else {
          this.$emit("finish", POSDetArticuloConfiguraciones);
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    
    finishChild(POSDetArticuloConfiguraciones) {
      this.loading = true;
      try {
        this.$emit("finish", POSDetArticuloConfiguraciones);
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    
    nextChild(POSDetArticuloConfiguraciones) {
      this.loading = true;
      try {
        POSDetArticuloConfiguraciones.forEach((x) => {
          this.configuracionesTemporal.push(x);
        });

        if (this.current == this.steps) {
          let response = [];
          this.configuracionesTemporal.forEach((x) => {
            response.push({ ...x });
          });
          this.configuracionesTemporal = [];
          if (this.child) {
            this.$emit("finishChild", response);
          } else {
            this.$emit("finish", response);
          }
        } else {
          this.current = this.current + 1;
        }
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
    
    nextStep() {
      if (this.steps > 1 && this.current < this.steps) {
        this.current = this.current + 1;
      }
    },
    
    backStep() {
      if (this.steps > 1 && this.current > 1) {
        this.current = this.current - 1;
      }
    },
    
    getSteps(configuration) {
      if (!configuration || !configuration.hijos) return 0;
      return configuration.hijos.length;
    },
    
    reload(value) {
      this.loading = true;
      try {
        console.log(value);
        this.localValue.forEach((padre) => {
          if(padre.selected == true){
            padre.padre = true;
            padre.selected = true;
            padre.color = "primary";
          } else {
            padre.selected = false;
            padre.dblCantidad = 0;
          }
          
          if (padre.hijos) {
            padre.hijos.forEach((hijo) => {
              if(hijo.selected == true){
                hijo.selected = true;
                hijo.color = "primary";
              } else {
                hijo.selected = false;
                hijo.dblCantidad = 0;
              }
              
              if (hijo.hijos) {
                hijo.hijos.forEach((nieto) => {
                  if(nieto.selected == true){
                    nieto.selected = true;
                    nieto.color = "primary";
                  } else {
                    nieto.selected = false;
                    nieto.dblCantidad = 0;
                  }
                  
                  if (nieto.hijos) {
                    nieto.hijos.forEach((bisnieto) => {
                      if(bisnieto.selected == true){
                        bisnieto.selected = true;
                        bisnieto.color = "primary";
                      } else {
                        bisnieto.selected = false;
                        bisnieto.dblCantidad = 0;
                      }
                    });
                  }
                });
              }
            });
          }
        });
      } catch (e) {
        this.$toast.error(ErrorWeb(e), new Toast());
      } finally {
        this.loading = false;
      }
    },
  },
  
  watch: {
    steps(val) {
      if (val === 1) {
        this.current = 1;
      } else if (this.current > val) {
        this.current = val;
      }
    },
    
    localValue(newValue) {
      this.$emit("input", newValue);
    },
    
    value(newValue) {
      this.localValue = newValue;
    },
  },
  
  mounted() {
    if (this.steps === 1) {
      this.current = 1;
    }
  },
};
</script>

<style></style>